import {SmartComponent} from "smart-component-js";

class ScreensetComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element
        this.screen = this.element.dataset.screen || "gigya-login-screen";
        // le screen del profilo, dei consensi e del cambio password stanno in una screenset Gigya
        // diversa da quella di login/registrazione
        const isProfileScreen = this.screen.startsWith("gigya-update-profile")
            || ["gigya-privacy-screen", "gigya-change-password-screen"].includes(this.screen);
        this.screenSet = isProfileScreen
            ? "Restyle2026-ProfileUpdate"
            : "Restyle2026-RegistrationLogin";
        this.init();
    }


    createScreenset() {
        gigya.accounts.showScreenSet({
            containerID: `${this.screen}-wrapper`,
            mobileScreenSet: "",
            screenSet: this.screenSet,
            startScreen: `${this.screen}`,
            authFlow: "redirect",
            onAfterScreenLoad: function (event) {
                window.scrollTo(0, 0);
            }
        });
    }


    init() {
        this.createScreenset();
    }
}

export default ScreensetComponent;
